var map = {
	"./elephant_ui_disappointed": 1073,
	"./elephant_ui_disappointed.svg": 1073,
	"./elephant_ui_greeting": 1070,
	"./elephant_ui_greeting.svg": 1070,
	"./elephant_ui_plane": 1065,
	"./elephant_ui_plane.svg": 1065,
	"./elephant_ui_working": 681,
	"./elephant_ui_working.svg": 681,
	"./friends-cropped": 1074,
	"./friends-cropped.png": 1074,
	"./glitch-preview": 1075,
	"./glitch-preview.jpg": 1075,
	"./logo_warn_glitch": 169,
	"./logo_warn_glitch.svg": 169,
	"./mbstobon-ui-0": 1076,
	"./mbstobon-ui-0.png": 1076,
	"./mbstobon-ui-1": 1077,
	"./mbstobon-ui-1.png": 1077,
	"./mbstobon-ui-2": 1078,
	"./mbstobon-ui-2.png": 1078,
	"./mbstobon-ui-3": 1079,
	"./mbstobon-ui-3.png": 1079,
	"./wave-drawer": 1080,
	"./wave-drawer-glitched": 1081,
	"./wave-drawer-glitched.png": 1081,
	"./wave-drawer.png": 1080
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1120;